var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "d-flex flex-column flex-xl-row" }, [
      _c("div", { staticClass: "calendar-wrapper pb-3 pr-xl-3" }, [
        _c(
          "a",
          {
            staticClass: "calendar-icon",
            attrs: { href: _vm.getEventUrl(), target: "_blank" },
            on: { click: _vm.handleEventClick }
          },
          [
            _c("calendar-icon", {
              attrs: {
                "month-text": _vm.formattedEventData.calendarMonthText,
                "day-text": _vm.formattedEventData.calendarDayText
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _c(
          "a",
          {
            staticClass: "event-title",
            attrs: { href: _vm.getEventUrl(), target: "_blank" },
            on: { click: _vm.handleEventClick }
          },
          [
            _vm._v(
              "\n        " + _vm._s(_vm.formattedEventData.title) + "\n      "
            )
          ]
        ),
        _vm._v(" "),
        _c("div", [_vm._v(_vm._s(_vm.formattedEventData.eventDescriptionText))])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7370cc5a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7370cc5a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/events/EventCard.vue
// module id = null
// module chunks = 